import React from 'react';
import { Route } from 'react-router-dom';

// Hub module pages (job tracker + timeclock — REQ-12)
const HubJobs = React.lazy(() => import('../pages/hub/HubJobs'));
const HubClock = React.lazy(() => import('../pages/hub/HubClock'));

export const hubRoutes = [
  <Route key="/hub/jobs" path="/hub/jobs" element={<HubJobs />} />,
  <Route key="/hub/clock" path="/hub/clock" element={<HubClock />} />,
];
